// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General Styling */
body {
  font-family: 'Arial', sans-serif;
  background-color: #f7f7f7; /* Lighter background for modern look */
  margin: 0;
  padding-top: 75px;
  box-sizing: border-box;
}

/* Fixed Header */
.header {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;
  background-color: #343a40;
  color: white;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  background: linear-gradient(to right, #3498DB, #F5F5F5);


}

/* Footer */
.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: #343a40;
  color: white;
  text-align: center;
  padding: 10px 0;
  z-index: 999;
  font-size: 0.85rem;
}

/* .sidebar {
  height: 100vh;
  width: 250px;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #f8f9fa;
  padding-top: 70px;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
} */


.sidebar .navbar .navbar-nav {
  background-color: #F5F5F5;;
  
  width: 250px;
  padding: 15px;
  min-height: 90vh;
  padding-top: 70px;
  position: fixed; /* Fix sidebar to the left */
  left: 0;
  top: 0;
  overflow-y: auto; 
  
}

.sidebar a {
  color: #1c3146;
  padding: 10px 15px;
  display: block;
  text-decoration: none;
  transition: 0.3s;
}





.navbar {
  width: 100%;
  
}
.navbar-nav {
  display: flex;
  justify-content: space-evenly; /* Ensures equal spacing */
  
  width: 70%;
}

.navbar-nav a {
  color: #282525;
  font-size: 1.15rem;
  
  transition: background-color 0.3s ease, color 0.3s ease;

  display: flex; /* Flexbox ensures equal height */
  align-items: center; /* Centers text vertically */
  justify-content: center; /* Centers text horizontally */
  
  flex: 1 1; /* Makes each link take equal width */
  
  text-align: center;
  text-decoration: none; /* Removes underline */
  border-radius: 25px;
}

/* Hover & Active Styles */
.navbar-nav a:hover {
  border-radius: 25px;
  background-color: #1f587e;
  color: white;
}

.navbar-nav a.active {
  background-color: #1f587e;
  color: white;
}

.navbar-collapase {
  margin-top: 10px;
  background-color: white;
}


.nav-link:hover {
  background-color: #007bff;
  color: #fff;
}

.nav-dropdown {
  margin-top: 10px;
  background-color: white;
}

.nav-dropdown .dropdown-item {
  font-size: 0.9rem;
  padding: 8px 15px;
}

.nav-dropdown .dropdown-item:hover {
  background-color: #007bff;
  color: #fff;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .sidebar {
    width: 100%;
    height: auto;
    position: relative;
  }
}




/* Main Login Page Styling */
.login-page {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fafafa;
  padding: 0 70px;
  min-height: 80vh;
}

.offer-section {
  flex: 1 1;
  color: #001f3f; /* Darker blue for more contrast */
  padding-left: 50px;
  text-align: left;
}

.offer-section h1 {
  font-size: 3.5rem;
  margin-bottom: 10px;
  font-weight: bold;
}

.offer-section h2 {
  font-size: 1.8rem;
  margin-bottom: 10px;
}

.offer-section h3 {
  font-size: 1.2rem;
  margin-bottom: 20px;
  color: #ff4136; /* Red color for heart */
}

.form-section {
  flex: 0.4 1;
  background-color: #ffffff;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.form-section h2 {
  font-size: 1.75rem;
  margin-bottom: 20px;
  color: #333;
}

/* Form Group */
.form-group {
  margin-bottom: 15px;
  text-align: left;
}

.form-group label {
  font-size: 0.9rem;
  color: #555;
}

.input-field {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-top: 5px;
  font-size: 1rem;
}

/* Submit Button */
.submit-button {
  width: 100%;
  padding: 10px;
  background-color: #007bff; /* Blue button */
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 1rem;
  cursor: pointer;
  margin-top: 10px;
  transition: background-color 0.3s ease;
}

.submit-button:hover {
  background-color: #0056b3; /* Darker blue on hover */
}

/* Register Section */
.register-section {
  margin-top: 20px;
}

.register-link {
  background: none;
  border: none;
  color: #007bff;
  text-decoration: underline;
  cursor: pointer;
  font-size: 0.9rem;
}

.register-link:hover {
  color: #0056b3;
}

/* Modal Styling */
.modal-body .form-group {
  margin-bottom: 15px;
}

.modal-body .form-group label {
  font-size: 0.9rem;
  color: #555;
}

.modal-body .input-field {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-top: 5px;
}

.modal-footer {
  justify-content: center;
}

.modal-footer .submit-button {
  width: 100%;
}

/* Theme Section */
.home-container {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 40px;
  gap: 20px; /* Provide more space between items */
}

.theme {
  flex: 0 0 45%;
  background-color: whitesmoke;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 30px;
  transition: transform 0.3s ease;
}

.theme:hover {
  transform: scale(1.05); /* Slight zoom on hover */
}

/* Order Form */
.order-form {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 8px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
}

.form-input,
.form-textarea,
.form-file {
  width: 100%;
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #ccc;
}

.form-textarea {
  height: 100px;
}

.submit-button {
  padding: 10px 15px;
  background-color: #007bff;
  color: white;
  cursor: pointer;
}

.submit-button:hover {
  background-color: #0056b3;
}

/* Table Styles */
.table-header th {
  padding: 10px 15px;
  min-width: 120px;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.bi-trash {
  font-size: 1.2em;
  margin-right: 10px;
  cursor: pointer;
}

.bi-trash:hover {
  color: darkred;
}

/* Media Queries */
@media (max-width: 768px) {
  .login-page {
    flex-direction: column;
    padding: 20px;
  }

  .form-section {
    width: 100%;
  }

  .offer-section {
    text-align: center;
    padding: 0;
  }

  .home-container {
    flex-direction: column;
  }

  .theme {
    width: 100%;
  }
}




/* Default select styling */
/* styles.css */

.select-ready {
  background-color: #d4edda; /* Light green */
}

.select-need-payment {
  background-color: #f8d7da; /* Light red */
}

.select-pending {
  background-color: #fff3cd; /* Light yellow */
}

.select-pending-artwork {
  background-color: #e2e3e5; /* Light gray */
}

.select-approved {
  background-color: #c3e6cb; /* Light green */
}

.select-harddate {
  background-color: red; /* Yellow */
}

.select-pending-approval {
  background-color: #d1ecf1; /* Light blue */
}

.select-in-progress {
  background-color: lightblue; /* Light green */
}

.select-onhold {
  background-color: red; /* Yellow */
}

.select-done {
  background-color: lightseagreen; /* Light blue */
}

.select-completed {
  background-color: lightcoral; /* Light blue */
}
.home-page {
  position: relative; /* Establish positioning context */
  padding: 20px; /* General padding */
  margin-left: 250px;
}

.dropdown {
  position: relative; /* Relative positioning for the dropdown */

}

.dropdown-button {
  padding: 10px 15px; /* Button padding */
  background-color: #0088FE; /* Button color */
  color: white; /* Text color */
  border: none; /* Remove default border */
  border-radius: 5px; /* Rounded corners */
  cursor: pointer; /* Pointer cursor on hover */
}

.dropdown-content {
  position: absolute; /* Position below the button */
  background-color: white; /* Background color */
  border: 1px solid #ddd; /* Border */
  border-radius: 5px; /* Rounded corners */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); /* Shadow */
  margin-top: 5px; /* Space between button and dropdown */
  z-index: 1000; /* Ensure it appears above other content */
}

.home-container {
  display: flex; /* Use flexbox for themes */
  flex-wrap: wrap; /* Allow wrapping */
  margin-bottom: 40px; 
  gap: 10px; /* Reduce the space between themes */
}

.theme {
  flex: 0 0 45%; /* Width of each theme */
  background-color: whitesmoke;
  padding: 10px; /* Reduce padding to minimize height */
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 30px; /* Reduce margin between rows */
  transition: transform 0.3s ease;
}

.theme:hover {
  transform: scale(1.05); /* Keep the zoom effect on hover */
}


/* TableStyles.css */
.table-header th {
  padding: 10px 15px;
  min-width: 120px;
  text-align: left;
  white-space: nowrap; /* Prevent text wrapping */
  overflow: hidden; /* Hide overflow text */
  text-overflow: ellipsis; /* Add ellipsis for overflow */
}

.table-header .wide-col {
  min-width: 150px;
}

.table-header .extra-wide-col {
  min-width: 200px;
}

.table-header .sort-icon {
  cursor: pointer;
  margin-left: 5px;
}
.bi-trash {
  font-size: 1.2em;
 
  margin-right: 10px;
}

.bi-trash:hover {
  color: darkred;
}



@media print {
  body * {
    visibility: hidden; /* Hide everything */
  }
  .printable-modal, .printable-modal * {
    visibility: visible; /* Show only the modal */
  }
  .printable-modal {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
}


.forgot-password-button {
  background-color: white; /* Primary blue color */
  color: red; /* White text */
  border: none; /* Remove default border */
  padding: 10px 20px; /* Add padding for better spacing */
  

  cursor: pointer; /* Pointer cursor on hover */
  
}



/* General container styling */
.form-container {
  max-width: 500px;
  margin: 20px auto;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  align-items: center;
}

/* Form Title */
.form-container h2 {
  text-align: center;
  margin-bottom: 20px;
  color: #333;
}

/* Grid layout for form fields */
.form-grid {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 15px;
}

/* Label styling */
.form-grid label {
  display: flex;
  flex-direction: column;
  font-weight: 600;
  color: #555;
}

/* Input Fields */
.form-grid input {
  padding: 8px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 5px;
  outline: none;
  transition: 0.3s;
}

/* Input Focus Effect */
.form-grid input:focus {
  border-color: #007bff;
  box-shadow: 0px 0px 5px rgba(0, 123, 255, 0.2);
}

/* Submit Button */
.submit-btn {
  display: block;
  width: 100%;
  margin-top: 20px;
  padding: 10px;
  font-size: 16px;
  font-weight: bold;
  color: white;
  background-color: #007bff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: 0.3s;
}

.submit-btn:hover {
  background-color: #0056b3;
}

/* Responsive Design */
@media (max-width: 768px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
}





`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,gCAAgC;EAChC,yBAAyB,EAAE,uCAAuC;EAClE,SAAS;EACT,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,uDAAuD;;;AAGzD;;AAEA,WAAW;AACX;EACE,eAAe;EACf,OAAO;EACP,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;;;;;;;;GASG;;;AAGH;EACE,yBAAyB;;EAEzB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,eAAe,EAAE,4BAA4B;EAC7C,OAAO;EACP,MAAM;EACN,gBAAgB;;AAElB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;;;;;AAMA;EACE,WAAW;;AAEb;AACA;EACE,aAAa;EACb,6BAA6B,EAAE,0BAA0B;;EAEzD,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,kBAAkB;;EAElB,uDAAuD;;EAEvD,aAAa,EAAE,iCAAiC;EAChD,mBAAmB,EAAE,4BAA4B;EACjD,uBAAuB,EAAE,8BAA8B;;EAEvD,SAAO,EAAE,qCAAqC;;EAE9C,kBAAkB;EAClB,qBAAqB,EAAE,sBAAsB;EAC7C,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;;AAGA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;AACF;;;;;AAKA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,cAAc,EAAE,kCAAkC;EAClD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc,EAAE,wBAAwB;AAC1C;;AAEA;EACE,WAAS;EACT,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,aAAa;EACb,yBAAyB,EAAE,gBAAgB;EAC3C,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB,EAAE,yBAAyB;AACtD;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS,EAAE,qCAAqC;AAClD;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB,EAAE,yBAAyB;AACnD;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;;;EAGE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE;IACE,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;;;;AAKA,2BAA2B;AAC3B,eAAe;;AAEf;EACE,yBAAyB,EAAE,gBAAgB;AAC7C;;AAEA;EACE,yBAAyB,EAAE,cAAc;AAC3C;;AAEA;EACE,yBAAyB,EAAE,iBAAiB;AAC9C;;AAEA;EACE,yBAAyB,EAAE,eAAe;AAC5C;;AAEA;EACE,yBAAyB,EAAE,gBAAgB;AAC7C;;AAEA;EACE,qBAAqB,EAAE,WAAW;AACpC;;AAEA;EACE,yBAAyB,EAAE,eAAe;AAC5C;;AAEA;EACE,2BAA2B,EAAE,gBAAgB;AAC/C;;AAEA;EACE,qBAAqB,EAAE,WAAW;AACpC;;AAEA;EACE,+BAA+B,EAAE,eAAe;AAClD;;AAEA;EACE,4BAA4B,EAAE,eAAe;AAC/C;AACA;EACE,kBAAkB,EAAE,kCAAkC;EACtD,aAAa,EAAE,oBAAoB;EACnC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB,EAAE,0CAA0C;;AAEhE;;AAEA;EACE,kBAAkB,EAAE,mBAAmB;EACvC,yBAAyB,EAAE,iBAAiB;EAC5C,YAAY,EAAE,eAAe;EAC7B,YAAY,EAAE,0BAA0B;EACxC,kBAAkB,EAAE,oBAAoB;EACxC,eAAe,EAAE,4BAA4B;AAC/C;;AAEA;EACE,kBAAkB,EAAE,8BAA8B;EAClD,uBAAuB,EAAE,qBAAqB;EAC9C,sBAAsB,EAAE,WAAW;EACnC,kBAAkB,EAAE,oBAAoB;EACxC,wCAAwC,EAAE,WAAW;EACrD,eAAe,EAAE,sCAAsC;EACvD,aAAa,EAAE,0CAA0C;AAC3D;;AAEA;EACE,aAAa,EAAE,2BAA2B;EAC1C,eAAe,EAAE,mBAAmB;EACpC,mBAAmB;EACnB,SAAS,EAAE,oCAAoC;AACjD;;AAEA;EACE,aAAa,EAAE,wBAAwB;EACvC,4BAA4B;EAC5B,aAAa,EAAE,sCAAsC;EACrD,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB,EAAE,+BAA+B;EACpD,+BAA+B;AACjC;;AAEA;EACE,sBAAsB,EAAE,kCAAkC;AAC5D;;;AAGA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB,EAAE,0BAA0B;EAC/C,gBAAgB,EAAE,uBAAuB;EACzC,uBAAuB,EAAE,8BAA8B;AACzD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;;;AAIA;EACE;IACE,kBAAkB,EAAE,oBAAoB;EAC1C;EACA;IACE,mBAAmB,EAAE,wBAAwB;EAC/C;EACA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;EACb;AACF;;;AAGA;EACE,uBAAuB,EAAE,uBAAuB;EAChD,UAAU,EAAE,eAAe;EAC3B,YAAY,EAAE,0BAA0B;EACxC,kBAAkB,EAAE,mCAAmC;;;EAGvD,eAAe,EAAE,4BAA4B;;AAE/C;;;;AAIA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,kBAAkB;AAClB;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* General Styling */\nbody {\n  font-family: 'Arial', sans-serif;\n  background-color: #f7f7f7; /* Lighter background for modern look */\n  margin: 0;\n  padding-top: 75px;\n  box-sizing: border-box;\n}\n\n/* Fixed Header */\n.header {\n  position: fixed;\n  top: 0;\n  width: 100%;\n  z-index: 1000;\n  background-color: #343a40;\n  color: white;\n  height: 70px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 20px;\n  background: linear-gradient(to right, #3498DB, #F5F5F5);\n\n\n}\n\n/* Footer */\n.footer {\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  background-color: #343a40;\n  color: white;\n  text-align: center;\n  padding: 10px 0;\n  z-index: 999;\n  font-size: 0.85rem;\n}\n\n/* .sidebar {\n  height: 100vh;\n  width: 250px;\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-color: #f8f9fa;\n  padding-top: 70px;\n  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);\n} */\n\n\n.sidebar .navbar .navbar-nav {\n  background-color: #F5F5F5;;\n  \n  width: 250px;\n  padding: 15px;\n  min-height: 90vh;\n  padding-top: 70px;\n  position: fixed; /* Fix sidebar to the left */\n  left: 0;\n  top: 0;\n  overflow-y: auto; \n  \n}\n\n.sidebar a {\n  color: #1c3146;\n  padding: 10px 15px;\n  display: block;\n  text-decoration: none;\n  transition: 0.3s;\n}\n\n\n\n\n\n.navbar {\n  width: 100%;\n  \n}\n.navbar-nav {\n  display: flex;\n  justify-content: space-evenly; /* Ensures equal spacing */\n  \n  width: 70%;\n}\n\n.navbar-nav a {\n  color: #282525;\n  font-size: 1.15rem;\n  \n  transition: background-color 0.3s ease, color 0.3s ease;\n\n  display: flex; /* Flexbox ensures equal height */\n  align-items: center; /* Centers text vertically */\n  justify-content: center; /* Centers text horizontally */\n  \n  flex: 1; /* Makes each link take equal width */\n  \n  text-align: center;\n  text-decoration: none; /* Removes underline */\n  border-radius: 25px;\n}\n\n/* Hover & Active Styles */\n.navbar-nav a:hover {\n  border-radius: 25px;\n  background-color: #1f587e;\n  color: white;\n}\n\n.navbar-nav a.active {\n  background-color: #1f587e;\n  color: white;\n}\n\n.navbar-collapase {\n  margin-top: 10px;\n  background-color: white;\n}\n\n\n.nav-link:hover {\n  background-color: #007bff;\n  color: #fff;\n}\n\n.nav-dropdown {\n  margin-top: 10px;\n  background-color: white;\n}\n\n.nav-dropdown .dropdown-item {\n  font-size: 0.9rem;\n  padding: 8px 15px;\n}\n\n.nav-dropdown .dropdown-item:hover {\n  background-color: #007bff;\n  color: #fff;\n}\n\n/* Mobile Responsive */\n@media (max-width: 768px) {\n  .sidebar {\n    width: 100%;\n    height: auto;\n    position: relative;\n  }\n}\n\n\n\n\n/* Main Login Page Styling */\n.login-page {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: #fafafa;\n  padding: 0 70px;\n  min-height: 80vh;\n}\n\n.offer-section {\n  flex: 1;\n  color: #001f3f; /* Darker blue for more contrast */\n  padding-left: 50px;\n  text-align: left;\n}\n\n.offer-section h1 {\n  font-size: 3.5rem;\n  margin-bottom: 10px;\n  font-weight: bold;\n}\n\n.offer-section h2 {\n  font-size: 1.8rem;\n  margin-bottom: 10px;\n}\n\n.offer-section h3 {\n  font-size: 1.2rem;\n  margin-bottom: 20px;\n  color: #ff4136; /* Red color for heart */\n}\n\n.form-section {\n  flex: 0.4;\n  background-color: #ffffff;\n  padding: 30px;\n  border-radius: 10px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  text-align: center;\n}\n\n.form-section h2 {\n  font-size: 1.75rem;\n  margin-bottom: 20px;\n  color: #333;\n}\n\n/* Form Group */\n.form-group {\n  margin-bottom: 15px;\n  text-align: left;\n}\n\n.form-group label {\n  font-size: 0.9rem;\n  color: #555;\n}\n\n.input-field {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  margin-top: 5px;\n  font-size: 1rem;\n}\n\n/* Submit Button */\n.submit-button {\n  width: 100%;\n  padding: 10px;\n  background-color: #007bff; /* Blue button */\n  color: white;\n  border: none;\n  border-radius: 5px;\n  font-size: 1rem;\n  cursor: pointer;\n  margin-top: 10px;\n  transition: background-color 0.3s ease;\n}\n\n.submit-button:hover {\n  background-color: #0056b3; /* Darker blue on hover */\n}\n\n/* Register Section */\n.register-section {\n  margin-top: 20px;\n}\n\n.register-link {\n  background: none;\n  border: none;\n  color: #007bff;\n  text-decoration: underline;\n  cursor: pointer;\n  font-size: 0.9rem;\n}\n\n.register-link:hover {\n  color: #0056b3;\n}\n\n/* Modal Styling */\n.modal-body .form-group {\n  margin-bottom: 15px;\n}\n\n.modal-body .form-group label {\n  font-size: 0.9rem;\n  color: #555;\n}\n\n.modal-body .input-field {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  margin-top: 5px;\n}\n\n.modal-footer {\n  justify-content: center;\n}\n\n.modal-footer .submit-button {\n  width: 100%;\n}\n\n/* Theme Section */\n.home-container {\n  display: flex;\n  flex-wrap: wrap;\n  margin-bottom: 40px;\n  gap: 20px; /* Provide more space between items */\n}\n\n.theme {\n  flex: 0 0 45%;\n  background-color: whitesmoke;\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  margin-bottom: 30px;\n  transition: transform 0.3s ease;\n}\n\n.theme:hover {\n  transform: scale(1.05); /* Slight zoom on hover */\n}\n\n/* Order Form */\n.order-form {\n  max-width: 600px;\n  margin: 0 auto;\n  padding: 20px;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 5px;\n}\n\n.form-input,\n.form-textarea,\n.form-file {\n  width: 100%;\n  padding: 10px;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n}\n\n.form-textarea {\n  height: 100px;\n}\n\n.submit-button {\n  padding: 10px 15px;\n  background-color: #007bff;\n  color: white;\n  cursor: pointer;\n}\n\n.submit-button:hover {\n  background-color: #0056b3;\n}\n\n/* Table Styles */\n.table-header th {\n  padding: 10px 15px;\n  min-width: 120px;\n  text-align: left;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.bi-trash {\n  font-size: 1.2em;\n  margin-right: 10px;\n  cursor: pointer;\n}\n\n.bi-trash:hover {\n  color: darkred;\n}\n\n/* Media Queries */\n@media (max-width: 768px) {\n  .login-page {\n    flex-direction: column;\n    padding: 20px;\n  }\n\n  .form-section {\n    width: 100%;\n  }\n\n  .offer-section {\n    text-align: center;\n    padding: 0;\n  }\n\n  .home-container {\n    flex-direction: column;\n  }\n\n  .theme {\n    width: 100%;\n  }\n}\n\n\n\n\n/* Default select styling */\n/* styles.css */\n\n.select-ready {\n  background-color: #d4edda; /* Light green */\n}\n\n.select-need-payment {\n  background-color: #f8d7da; /* Light red */\n}\n\n.select-pending {\n  background-color: #fff3cd; /* Light yellow */\n}\n\n.select-pending-artwork {\n  background-color: #e2e3e5; /* Light gray */\n}\n\n.select-approved {\n  background-color: #c3e6cb; /* Light green */\n}\n\n.select-harddate {\n  background-color: red; /* Yellow */\n}\n\n.select-pending-approval {\n  background-color: #d1ecf1; /* Light blue */\n}\n\n.select-in-progress {\n  background-color: lightblue; /* Light green */\n}\n\n.select-onhold {\n  background-color: red; /* Yellow */\n}\n\n.select-done {\n  background-color: lightseagreen; /* Light blue */\n}\n\n.select-completed {\n  background-color: lightcoral; /* Light blue */\n}\n.home-page {\n  position: relative; /* Establish positioning context */\n  padding: 20px; /* General padding */\n  margin-left: 250px;\n}\n\n.dropdown {\n  position: relative; /* Relative positioning for the dropdown */\n\n}\n\n.dropdown-button {\n  padding: 10px 15px; /* Button padding */\n  background-color: #0088FE; /* Button color */\n  color: white; /* Text color */\n  border: none; /* Remove default border */\n  border-radius: 5px; /* Rounded corners */\n  cursor: pointer; /* Pointer cursor on hover */\n}\n\n.dropdown-content {\n  position: absolute; /* Position below the button */\n  background-color: white; /* Background color */\n  border: 1px solid #ddd; /* Border */\n  border-radius: 5px; /* Rounded corners */\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); /* Shadow */\n  margin-top: 5px; /* Space between button and dropdown */\n  z-index: 1000; /* Ensure it appears above other content */\n}\n\n.home-container {\n  display: flex; /* Use flexbox for themes */\n  flex-wrap: wrap; /* Allow wrapping */\n  margin-bottom: 40px; \n  gap: 10px; /* Reduce the space between themes */\n}\n\n.theme {\n  flex: 0 0 45%; /* Width of each theme */\n  background-color: whitesmoke;\n  padding: 10px; /* Reduce padding to minimize height */\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  margin-bottom: 30px; /* Reduce margin between rows */\n  transition: transform 0.3s ease;\n}\n\n.theme:hover {\n  transform: scale(1.05); /* Keep the zoom effect on hover */\n}\n\n\n/* TableStyles.css */\n.table-header th {\n  padding: 10px 15px;\n  min-width: 120px;\n  text-align: left;\n  white-space: nowrap; /* Prevent text wrapping */\n  overflow: hidden; /* Hide overflow text */\n  text-overflow: ellipsis; /* Add ellipsis for overflow */\n}\n\n.table-header .wide-col {\n  min-width: 150px;\n}\n\n.table-header .extra-wide-col {\n  min-width: 200px;\n}\n\n.table-header .sort-icon {\n  cursor: pointer;\n  margin-left: 5px;\n}\n.bi-trash {\n  font-size: 1.2em;\n \n  margin-right: 10px;\n}\n\n.bi-trash:hover {\n  color: darkred;\n}\n\n\n\n@media print {\n  body * {\n    visibility: hidden; /* Hide everything */\n  }\n  .printable-modal, .printable-modal * {\n    visibility: visible; /* Show only the modal */\n  }\n  .printable-modal {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n  }\n}\n\n\n.forgot-password-button {\n  background-color: white; /* Primary blue color */\n  color: red; /* White text */\n  border: none; /* Remove default border */\n  padding: 10px 20px; /* Add padding for better spacing */\n  \n\n  cursor: pointer; /* Pointer cursor on hover */\n  \n}\n\n\n\n/* General container styling */\n.form-container {\n  max-width: 500px;\n  margin: 20px auto;\n  padding: 20px;\n  background: #f8f9fa;\n  border-radius: 10px;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n  align-items: center;\n}\n\n/* Form Title */\n.form-container h2 {\n  text-align: center;\n  margin-bottom: 20px;\n  color: #333;\n}\n\n/* Grid layout for form fields */\n.form-grid {\n  display: grid;\n  grid-template-columns: repeat(1, 1fr);\n  gap: 15px;\n}\n\n/* Label styling */\n.form-grid label {\n  display: flex;\n  flex-direction: column;\n  font-weight: 600;\n  color: #555;\n}\n\n/* Input Fields */\n.form-grid input {\n  padding: 8px;\n  font-size: 14px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  outline: none;\n  transition: 0.3s;\n}\n\n/* Input Focus Effect */\n.form-grid input:focus {\n  border-color: #007bff;\n  box-shadow: 0px 0px 5px rgba(0, 123, 255, 0.2);\n}\n\n/* Submit Button */\n.submit-btn {\n  display: block;\n  width: 100%;\n  margin-top: 20px;\n  padding: 10px;\n  font-size: 16px;\n  font-weight: bold;\n  color: white;\n  background-color: #007bff;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: 0.3s;\n}\n\n.submit-btn:hover {\n  background-color: #0056b3;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .form-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
